// import React from 'react'
import { theme } from '../../../../../presentation/styles/theme'

export const dataFormAddress = (data: any) => [
  {
    items: [
      {
        title: 'Endereço',
        subtitle: '',
        component: 'Title',
      },
      {
        component: 'InputGroup',
        inputs: [
          {
            component: 'InputMask',
            mask: 'CEP',
            name: 'zipcode',
            label: 'Informe o CEP',
            title: 'Informe o CEP',
            value: data?.address?.zipcode ?? '',
            required: true,
            placeholder: 'Digite aqui',
            validations: 'inputRequired',
          },
          {
            component: 'Input',
            name: 'fullname',
            label: 'Logradouro',
            title: 'Logradouro',
            value: data?.address?.fullname ?? '',
            required: true,
            placeholder: 'Digite aqui',
            validations: 'inputRequired',
          },
          {
            component: 'Input',
            name: 'houseNumber',
            label: 'Número',
            title: 'Número',
            value: data?.address?.houseNumber ?? '',
            required: true,
            placeholder: 'Digite aqui',
            validations: 'inputRequired',
            styleContainer: { width: '40%' },
          },
          {
            component: 'Input',
            name: 'complement',
            label: 'Complemento',
            title: 'Complemento',
            value: data?.address?.complement ?? '',
            placeholder: 'Digite aqui',
          },
        ],
      },
      {
        component: 'InputGroup',
        inputs: [
          {
            component: 'Input',
            name: 'district',
            label: 'Bairro',
            title: 'Bairro',
            value: data?.address?.district ?? '',
            required: true,
            placeholder: 'Digite aqui',
            validations: 'inputRequired',
          },
          {
            component: 'Input',
            name: 'city',
            label: 'Município',
            title: 'Município',
            value: data?.address?.city ?? '',
            required: true,
            placeholder: 'Digite aqui',
            validations: 'inputRequired',
          },
          {
            component: 'Input',
            name: 'reference',
            label: 'Referência',
            title: 'Referência',
            value: data?.address?.reference ?? '',
            placeholder: 'Digite aqui',
            styleContainer: { width: '40%' },
          },
          {
            component: 'InputMask',
            mask: 'UF',
            name: 'state',
            label: 'UF',
            title: 'UF',
            value: data?.address?.state ?? '',
            required: true,
            placeholder: 'Digite aqui',
            validations: 'inputRequired',
          },
        ],
      },
      {
        name: 'button_1',
        component: 'Button',
        title: 'Salvar e prosseguir',
        submittingText: 'Salvando...',
        style: { background: theme.colors.blue, width: '30%', marginTop: '45px' },
      },
    ],
  },
]

export const dataFormCompanie = (data: any) => [
  {
    items: [
      {
        title: 'Dados da empresa',
        subtitle: '',
        component: 'Title',
      },
      // {
      //   component: 'Warning',
      //   childrenComponent: () => (
      //     <p>
      //       <strong>Importante:</strong>
      //       {' '}
      //       Para emissão de NFC você precisa gerar Código CSC. cada estado
      //       brasileiro tem um processo e um site próprio para isso, seu
      //       contador é a pessoa mais apropriada para te ajudar nesse processo.
      //       <br />
      //       <strong>Dica:</strong>
      //       {' '}
      //       Durante o processo não será necessária a inclusão do CNPJ do
      //       FingerMenu somente os dados do contribuinte deverão ser informado.
      //       <br />
      //       <strong>Para SP é obrigatório o uso de SAT:</strong>
      //       {' '}
      //       Nós recomendamos o Controlid:
      //     </p>
      //   ),
      //   style: { marginBottom: '24px' },
      // },
      {
        component: 'InputGroup',
        inputs: [
          {
            component: 'Input',
            name: 'companieName',
            label: 'Razão Social',
            title: 'Razão Social',
            value: data?.companieName ?? '',
            validations: 'inputRequired',
            required: true,
            placeholder: 'Digite aqui',
            styleContainer: { width: '25%' },
          },
          {
            component: 'Input',
            name: 'fantasyName',
            label: 'Nome fantasia',
            title: 'Nome fantasia',
            value: data?.fantasyName ?? '',
            required: true,
            placeholder: 'Digite aqui',
            validations: 'inputRequired',
            styleContainer: { width: '25%' },
          },
          {
            component: 'InputMask',
            mask: 'CNPJ',
            name: 'cnpj',
            label: 'CNPJ',
            title: 'CNPJ',
            value: data?.cnpj ?? '',
            required: true,
            placeholder: 'Digite aqui',
            validations: 'inputRequired',
            styleContainer: { width: '25%' },
          },
        ],
      },
      {
        component: 'InputGroup',
        inputs: [
          {
            component: 'Input',
            name: 'stateRegistration',
            label: 'Inscrição Estadual (IE)',
            title: 'Inscrição Estadual (IE)',
            value: data?.stateRegistration ?? '',
            placeholder: 'Digite aqui',
            styleContainer: { width: '25%' },
          },
          {
            component: 'InputMask',
            mask: 'PHONE_NUMBER',
            name: 'phoneNumber',
            label: 'Telefone Comercial',
            title: 'Telefone Comercial',
            value: data?.phoneNumber ?? '',
            required: true,
            placeholder: 'Digite aqui',
            validations: 'inputRequired',
            styleContainer: { width: '25%' },
          },
          {
            component: 'Input',
            name: 'email',
            label: 'E-mail',
            title: 'E-mail',
            value: data?.email ?? '',
            required: true,
            placeholder: 'Digite aqui',
            validations: 'inputRequired',
            styleContainer: { width: '25%' },
          },
        ],
      },
      {
        component: 'InputGroup',
        inputs: [
          {
            name: 'button_2',
            type: 'button',
            component: 'Button',
            title: 'Voltar',
            onSubmit: data?.onSubmit,
            submittingText: 'Voltar',
            style: {
              background: theme.colors.mainBg,
              border: `1px solid ${theme.colors.blue}`,
              width: '25%',
              color: theme.colors.blue,
              marginTop: '45px',
            },
          },
          {
            name: 'button_3',
            component: 'Button',
            // title: 'Salvar e prosseguir',
            title: 'Salvar e concluir',
            submittingText: 'Salvando...',
            style: { background: theme.colors.blue, width: '25%', marginTop: '45px' },
          },
        ],
      },
    ],
  },
]

export const dataFormCertificate = (data: any) => [
  {
    items: [
      {
        title: 'Vincular certificado',
        subtitle: '',
        component: 'Title',
      },
      {
        component: 'Warning',
        text: 'Atenção: Selecione um arquivo .PFX ou .P12 do certificado digital (A1).',
        style: { marginBottom: '24px' },
      },
      {
        component: 'InputGroup',
        inputs: [
          {
            name: 'certificate',
            component: 'InputUpload',
            required: true,
            styleContainer: { width: '25%' },
            hasPreview: false,
          },
          {
            component: 'InputPassword',
            name: 'certificatePassword',
            label: 'Senha do Certificado',
            title: 'Senha do Certificado',
            value: data?.certificatePassword ?? '',
            type: 'password',
            required: true,
            placeholder: 'Digite aqui',
            styleContainer: { width: '25%' },
          },
        ],
      },
      {
        title: 'Regime e CSC (Código de Segurança do Contribuinte)',
        subtitle: '',
        component: 'Title',
      },
      {
        component: 'InputGroup',
        inputs: [
          {
            name: 'taxRegime',
            component: 'Select',
            value: data?.taxRegime ?? '',
            title: 'Regime Tributário',
            label: 'Regime Tributário',
            required: true,
            options: [
              { value: '1', label: '1 - Regime Normal' },
            ],
            placeholder: 'Selecionar...',
            hasPlusButton: false,
            styleContainer: { width: '25%' },
          },
          {
            component: 'Input',
            name: 'cscId',
            label: 'ID do CSC',
            title: 'ID do CSC',
            value: data?.cscId ?? '',
            required: true,
            placeholder: 'Digite aqui',
            validations: 'inputRequired',
            styleContainer: { width: '25%' },
          },
          {
            component: 'Input',
            name: 'cscCode',
            label: 'Código CSC',
            title: 'Código CSC',
            value: data?.cscCode ?? '',
            required: true,
            placeholder: 'Digite aqui',
            validations: 'inputRequired',
            styleContainer: { width: '25%' },
          },
        ],
      },
      {
        title: 'Regime e CSC (Código de Segurança do Contribuinte)',
        subtitle: '',
        component: 'Title',
      },
      {
        component: 'InputGroup',
        inputs: [
          {
            component: 'Input',
            name: 'sequential',
            label: 'Sequencial',
            title: 'Sequencial',
            value: data?.sequential ?? '',
            required: true,
            placeholder: 'Digite aqui',
            validations: 'inputRequired',
            styleContainer: { width: '25%' },
          },
          {
            component: 'Input',
            name: 'currentSeries',
            label: 'Série Atual',
            title: 'Série Atual',
            value: data?.currentSeries ?? '',
            required: true,
            placeholder: 'Digite aqui',
            validations: 'inputRequired',
            styleContainer: { width: '25%' },
          },
        ],
      },
      {
        component: 'InputGroup',
        inputs: [
          {
            name: 'button_4',
            component: 'Button',
            title: 'Voltar',
            submittingText: 'Voltar',
            onSubmit: data?.onSubmit,
            style: {
              background: theme.colors.mainBg,
              border: `1px solid ${theme.colors.blue}`,
              color: theme.colors.blue,
              width: '25%',
              marginTop: '45px',
            },
          },
          {
            name: 'button_5',
            component: 'Button',
            title: 'Salvar e prosseguir',
            submittingText: 'Salvando...',
            style: { background: theme.colors.blue, width: '25%', marginTop: '45px' },
          },
        ],
      },
    ],
  },
]
